export default __webpack_public_path__ + "static/media/bnb_logo.66b2f693.svg";